import { Link } from "react-router";

import type { DramaSeries } from "~/api/drama";

/** Posters are authored 2:3 and carry their own title art, so they are never cropped and never
 *  get a gradient laid over them — our own title sits below the poster, not on it. */
export function DramaCardLight({ series, idPrefix }: { series: DramaSeries; idPrefix: string }) {
  return (
    <Link
      id={`${idPrefix}-${series.id}`}
      to={`/cinema/detail?series=${encodeURIComponent(series.id)}`}
      className="flex flex-col gap-[8px]"
    >
      <div className="aspect-[2/3] w-full overflow-hidden rounded-[12px] bg-neutral-200">
        {series.thumbnail && <img src={series.thumbnail} alt="" loading="lazy" className="size-full object-cover" />}
      </div>
      {/* Two lines reserved whether or not the title needs them, so a row of cards has one
          baseline instead of one per title length. */}
      <p className="text-text-primary line-clamp-2 h-[40px] text-[14px] leading-[20px] font-semibold">{series.title}</p>
      {series.tags?.[0] && <p className="text-text-tertiary text-[12px] leading-[18px]">{series.tags[0]}</p>}
    </Link>
  );
}
